import types from './types';

// const swim = distance => ({
// type: types.SWIM,
// payload: {
// distance,
// },
// });

const setAdvertiserName = advertiserName => ({
  type: types.SET_ADVERTISER_NAME,
  payload: advertiserName,
});

const setIsFetching = isFetching => ({
  type: types.SET_IS_FETCHING,
  payload: isFetching,
});

const setIsPaymentSuccessful = isPaymentSuccessful => ({
  type: types.SET_IS_PAYMENT_SUCCESSFUL,
  payload: isPaymentSuccessful,
});

export default {
  setAdvertiserName,
  setIsFetching,
  setIsPaymentSuccessful,
};
